"use strict";
export const functionName = Symbol.for("functionName");
//# sourceMappingURL=functionName.js.map
